import React from 'react';
import { CanvaStyleAuth } from '../../components/auth/CanvaStyleAuth';
export function LoginPage() {
  const handleLogin = (data: any) => {
    console.log('Login data:', data);
    // Handle login logic here
    setTimeout(() => {
      window.location.href = '/';
    }, 1500);
  };
  return <CanvaStyleAuth mode="signin" onSubmit={handleLogin} data-id="element-7460" />;
}